import { Component } from '@angular/core';
import { Account, Post } from 'src/app/interfaces';
import { AccountService } from 'src/app/services/account.service';
import { PostService } from 'src/app/services/post.service';

@Component({
  selector: 'vl-posts',
  standalone: true,
  imports: [],
  templateUrl: './posts.component.html',
  styleUrl: './posts.component.scss'
})
export class PostsComponent {

  private account: Account = <Account>{}
  private posts: Post[] = <Post[]>[]

  constructor(private accountService: AccountService, private postService: PostService) {
    this.accountService.getAccount$().subscribe((account) => {
      if (account._id) {
        this.postService.getPostsByAccountId(account._id).subscribe((posts) => {
          this.posts = posts;
        });
        this.account = account;
      }
    });
  }

}
